import React, { useEffect } from "react";
import { ContentWrapper, NormalText, TimestampText } from "./Styled";
import { useParams } from "react-router-dom";
import { api } from "../../../../shared/hooks/api";
import {
    ProductTableText,
} from "../../single/Styled";
import { color } from "../../../../shared/styles";

export const EventLogProductOrderTab = () => {
    const { productOrderId } = useParams();
    const [{data: productOrderEventLog}, fetchProductOrderEventLog] = api.get(`/products/orders/${productOrderId}/changes`);
    const convertBooleanToString = (value: any) => {
        if (typeof value === "boolean") {
            return value ? "True" : "False";
        }
        return value;
    };

    return (
        <ContentWrapper>
            <ProductTableText>Sự kiện gần đây</ProductTableText>
            <div className="event-log-content">
                {productOrderEventLog?.map((event: any, index: number) => (
                    <div className="event-log-content_entry" key={index}>
                        <NormalText>
                            <div>
                                &#9872; — <span><b style={{ color: color.primary.BLUE_B100 }}>{event.history_user_name}</b> đã thay đổi:</span>
                                {event.fields.length === 0 &&
                                    " - Đơn hàng sản phẩm được tạo"}{" "}
                            </div>
                            <ul>
                                {event.fields.map((field: any) => (
                                    <li key={field}>
                                        <b style={{ color: color.secondary.CHARCOAL }}>{field}</b>:{" "}
                                        <i>
                                            {convertBooleanToString(
                                                event.changes[field][0]
                                            )}
                                        </i>{" "}
                                        <b>{"→"}</b>{" "}
                                        <i>
                                            {convertBooleanToString(
                                                event.changes[field][1]
                                            )}
                                        </i>
                                        ;
                                    </li>
                                ))}
                            </ul>
                        </NormalText>
                        <TimestampText>
                            {formatTimestamp(event.timestamp)}
                        </TimestampText>
                    </div>
                ))}
            </div>
        </ContentWrapper>
    );
};

export const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-indexed
    const year = date.getFullYear();
    const timeString = date.toLocaleTimeString();
    return `${day}/${month}/${year}, ${timeString}`;
};
